import { useInfiniteQuery, useQuery } from 'react-query'

import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { type ResearcherDomain } from '../../../../types/domain/researcher-domain'
import { getValidFilters } from '../../../../utils/filters'
import { getQueryStrinfied } from '../../../../utils/query'
import { api } from '../../../api'

export const fetchResearchers = async (filters: FiltersDomain) => {
  const query = getQueryStrinfied(getValidFilters(filters))

  const { data } = await api.get<PaginationDomain<ResearcherDomain>>(`/researchers?${query}`)
  return data
}

export const useResearchersQuery = (filters: FiltersDomain) => {
  return useQuery(
    ['researchers', filters],
    () => fetchResearchers(filters),
    { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true } // 1 hour
  )
}

export const useInfiniteResearchersQuery = (filters: FiltersDomain) => {
  return useInfiniteQuery(
    ['researchers', filters],
    ({ pageParam = 1 }) => fetchResearchers({ ...filters, page: pageParam }),
    {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      getNextPageParam ({ meta }) {
        return meta.hasNextPage ? meta.page + 1 : undefined
      },
    }
  )
}
